export const ELearningConstants = {
	MaterialSectionNote1: "※表示されている PDF教材 をクリックしてください。",
	MaterialSectionNote2:
		"※画面が切り替わりますので下の方のページまでご確認ください。",
	MaterialSectionWarningTitle: "⚠️ 重要：教材の確認について",
	MaterialSectionWarningBody1:
		"教材を確認し終えたら、元の画面に戻っていただき『教材を確認しました』にチェックを入れてください。",
	MaterialSectionWarningBody2:
		"チェックを入れないと設問に進むことができません。",
	MaterialSectionWarningBody3: "※必ず教材を最後までお読みください。",
	ELearning: "eラーニング",
	ConfirmMaterials: "教材の確認",
	Questions: "設問",
	Submit: "回答を提出",
	Retry: "再挑戦",
	Passed: "合格済み",
	NotAccessible:
		"このeラーニングは現在アクセスできません。公開期間をご確認ください。",
	AllQuestionsRequired: "すべての設問にお答えください。",
	PassedMessage: "おめでとうございます！すべての設問に正解し、合格しました。",
	PassedMessageCloseNote: "画面を閉じて問題ありません。",
	FailedMessage:
		"残念ながら不合格でした。教材を再度確認して、再挑戦してください。",
	PassedLabel: "合格済み",
	CompletedMessage: "受講完了しました",
	NotEligible:
		"受講できません。「稼働管理・事故報告責任者」の回答を先にお願いします。回答済みの場合はお手数ですが、担当部門への問い合わせをお願いします。",
	LearnerNameUnavailable:
		"受講できません。「稼働管理・事故報告責任者」の氏名を確認できませんでした。お手数ですが、担当部門への問い合わせをお願いします。",
	ResponsiblePersonSelection: "稼働管理・事故報告責任者の選択",
	ResponsiblePersonSelectionMessage: "今回受講するご本人の氏名を選択してください。",
	ResponsiblePersonSelectionNote:
		"ご本人以外の氏名を選択して受講することはできません。必ず登録されたご本人が受講いただきますようお願いいたします。",
	IdentityConfirmationTitle: "本人確認",
	IdentityConfirmationStatement: (name: string, officeName: string) =>
		`私は ${name}（${officeName}）です。`,
	IdentityConfirmation: "上記の氏名は私本人であることを確認しました",
	IdentityConfirmationRequired:
		"表示されている氏名が本人であることを確認のうえ、チェックを入れてください。",
	MaterialConfirmation: "教材を確認しました",
	MaterialConfirmationRequired: "教材を確認してからテストを受けてください。",
	Question: "問",
	Learner: "受講者",
	Explanation: "解説",
} as const;
